import { HsbcTable } from "@/components/HsbcTable";
import { renderResearchText } from "@/components/ResearchText";
import "./HsbcArticle.css";

export const HsbcFrontMatter = ({ content }) => <>
  <section className="lvmh-prelude shell" aria-labelledby="hsbc-summary-heading" data-testid="hsbc-executive-summary">
    <div className="lvmh-prelude-heading"><span aria-hidden="true">—</span><h2 id="hsbc-summary-heading" data-testid="hsbc-summary-heading">Executive Summary</h2></div>
    <div className="lvmh-prelude-copy">{content.summary.map((block, index) => <p key={block.text} data-testid={`hsbc-summary-paragraph-${index}`}>{renderResearchText(block.text, `hsbc-summary-${index}`)}</p>)}</div>
  </section>
  <section className="hsbc-key-idea shell" aria-labelledby="hsbc-key-idea-heading" data-testid="hsbc-key-idea">
    <h2 id="hsbc-key-idea-heading" data-testid="hsbc-key-idea-heading">Key Idea</h2>
    <p data-testid="hsbc-key-idea-text">{renderResearchText(content.keyIdea, "hsbc-key-idea")}</p>
  </section>
  <section className="hsbc-at-a-glance shell" aria-label="At a Glance" data-testid="hsbc-at-a-glance">
    <HsbcTable block={{ ...content.atAGlance, caption: "At a Glance" }} testId="hsbc-at-a-glance-data" headingLevel={2} />
  </section>
</>;